import { DirectionOptions } from '../../enums/common/direction-options';
import { ClinicalCaseStatus } from '../../enums/social-network/clinical-case/clinical-case-status';
import { SocialNetworkContentType } from '../../enums/social-network/social-network-content-type.enum';
import { SocialNetworkInstancePrivacyType } from '../../enums/social-network/social-network-instance-privacy-type.enum';
import { SocialNetworkReactions } from '../../enums/social-network/social-network-reactions.enum';
import { SocialNetworkThreadOwnerType } from '../../enums/social-network/social-network-thread-owner-type.enum';
import { SocialNetworkThreadType } from '../../enums/social-network/social-network-thread-type.enum';
import { PaginationOptions } from '../common/pagination-options';
import { ProfileEntity } from '../profile/profile-entity';
import { Tag } from '../tags/tag';
import { SocialAttachment } from './social-attachment';
import { SocialNetworkInstance } from './social-network-instance';
import { SocialNetworkInstanceImage } from './social-network-instance-image';
import { SocialNetworkReaction } from './social-network-reaction';
import { SocialNetworkState } from './social-network-state';

export class SocialNetWorkThread {
  public instancesId: string;
  public body: string;
  public commented: boolean;
  public customFeed: boolean;
  public instance: SocialNetworkInstance;
  public moderator: boolean;
  public owner: boolean;
  public profile: ProfileEntity;

  public token: string;
  public totalOfComments: number;
  public watching: boolean;
  public publishedAt?: Date;
  public countReactions?: SocialNetworkReaction[];
  public reaction?: SocialNetworkReactions;
  public attachments?: SocialAttachment[];
  public states?: SocialNetworkState[] = [];
  public repost?: SocialNetWorkThread;

  //meplis-cnp
  public description?: string;
  public threadId?: string;
  public images?: SocialNetworkInstanceImage[];
  //public contentType?: SocialNetworkContentType;
  public ownerType?: SocialNetworkThreadOwnerType;
  public type?: SocialNetworkThreadType;
  public videoTitle?: string;
  public videoUrl?: string;
  public videoViews?: number;
  public tags?: Tag[];
  public editable?: boolean;
  public deletable?: boolean;
  public following?: boolean;
  public externalId?: string;
  public numberOfMembers?: number;
  public membersIds?: string[];
  public privacy?: SocialNetworkInstancePrivacyType;
  public createdAt?: Date;
  public updatedAt?: Date;
  public slug?: string;
  public finished?: boolean;
  public about?: string;
  public otherInformations?: string;

  public title?: string;
  // meplis-cnp video options
  public duration?: number;
  public width?: number;
  public height?: number;
  public size?: number;
  public organizationName?: string;

  // opportunities fields
  public date?: Date;
  public timeCommitment?: string;
  public statusOpportunity?: string;
  public typeOpportunity?: string;
  public compensation?: string;
  public deadline?: string;
}

export class SocialNetWorkThreadList {
  public threads: SocialNetWorkThread[] = [];
  public pagination: PaginationOptions = {
    direction: DirectionOptions.desc,
    limit: 6,
    page: 0,
  };
}
